import { OrganizationSelectorItem } from "@nova/component-organization-selector"
import { ID } from "@nova/constants"
import { OrganizationExtended, WorkspaceMember } from "@nova/schemas"
import { findTagTreePath } from "@nova/util-tag-tree"
import { DiscriminatedUnion } from "@nova/util-ts"

export const convertDataTypeToInviteDestination = (entity: {
    id: string
    name: string
}): OrganizationSelectorItem => {
    return { id: entity.id, fullName: entity.name }
}

export const sortAndFilterMembers = (
    members: DiscriminatedUnion<WorkspaceMember>[],
    entityId: ID,
    workspace?: OrganizationExtended,
    project?: { tagId?: ID; id: ID }
) => {
    if (!workspace) return { directSorted: [], inheritedSorted: [] }

    const isWorkspaceLevel = workspace.id === entityId
    const tagTree = workspace.tagTree || {}

    //filter to get people with direct access
    const directFiltered = members.filter((member) => {
        const requestedAccess = member.permissions.accessRequestIds?.includes(entityId)
        if (isWorkspaceLevel) return !!member.permissions.workspaceAccess || requestedAccess
        const permissions = member.permissions.subRoles?.find(
            (role) => role.id === entityId
        )?.permission
        return !!permissions || requestedAccess
    })

    let path: string[] | null = []
    if (project?.tagId && project.id === entityId) {
        path = findTagTreePath(tagTree, project.tagId, [])
    } else {
        path = findTagTreePath(tagTree, entityId, [])
        path?.pop()
    }
    //filter to get people with inherited access
    const inheritedFiltered = !isWorkspaceLevel
        ? members.filter((member) => {
              const anyTreePermissions = member.permissions.subRoles?.some((role) =>
                  path?.includes(role.id)
              )
              return anyTreePermissions || !!member.permissions.workspaceAccess
          })
        : []

    const directSorted = directFiltered.toSorted((a, b) =>
        (a.fullName || "").localeCompare(b.fullName || "")
    )
    const inheritedSorted = inheritedFiltered.toSorted((a, b) =>
        (a.fullName || "").localeCompare(b.fullName || "")
    )
    return { directSorted, inheritedSorted }
}
